import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import useCategory from "./useCategory";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import InfoCard from "../../Components/Cards/InfoCard";
import swal from 'sweetalert';

export default function () {
  const { categoryFields, handleSubmit, setData, setErrors } = useCategory();
  const navigate = useNavigate();

  const addCategory = data => {
    const formData = new FormData();

    Object.entries(data).forEach(([property, value]) => {
      formData.append(`${property}`, value || '');
    });

    axios.post('categories', formData)
      .then(function (res) {
        if (res.status == 200) {
          swal('Category "' + res.data.category.name + '" has been created successfully!', {
            icon: "success",
          });
          navigate(-1);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  useEffect(() => {
    axios.get('categories/create').then(res => {
      setData(res.data.data);
    });
  }, []);

  return (
    <Card title="Add category">
      <form className="form w-100 row" onSubmit={handleSubmit(addCategory)}>
        <InfoCard />
        {categoryFields}
        <SubmitButton title="Add"
          classes="w-auto d-inline-block float-right mt-10" />
      </form>
    </Card>
  );
}